<div class="progress-wrapper" id="main-content">
    <ridango-page-content-wrapper>
        <ridango-progress-v2 [steps]="steps$ | async" [activeStep]="activeStep$ | async"></ridango-progress-v2>
    </ridango-page-content-wrapper>
</div>

<div class="block--content block">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>
    </ridango-page-content-wrapper>
    <ridango-ui-basic-loading-spinner
        *ngIf="productsLoading$ | async"
        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"></ridango-ui-basic-loading-spinner>
    <div class="ticket" *ngIf="(productsLoading$ | async) === false && (productCategoryTypesLoaded$ | async)">
        <ridango-page-content-wrapper *ngIf="env.IS_CORPORATE && !corporateTravelCardsSelected">
            <rwidget-corp-card-selection
                (corporateCardsSelected)="corporateCardsSelected()"></rwidget-corp-card-selection>
        </ridango-page-content-wrapper>
        <ridango-page-content-wrapper *ngIf="!env.IS_CORPORATE || corporateTravelCardsSelected">
            <button
                class="hidden items-center md:flex md:py-3"
                *ngIf="env.IS_CORPORATE"
                (click)="backToSelectCorporateTravelCards()">
                <div class="flex w-9 flex-col justify-center">
                    <mat-icon class="fill-primary" svgIcon="ticket-back"></mat-icon>
                </div>
                {{ 'LOCAL_BTN_BACK' | translate }}
            </button>
            <ng-container *ngFor="let section of purchaseFeature.SECTIONS; let i = index">
                <ng-container [ngSwitch]="section">
                    <!-- zones -->
                    <rwidget-stops-zones-selector
                        *ngSwitchCase="'ZONE'"
                        [travelBetweenZones]="purchaseFeature.TRAVEL_BETWEEN_ZONES"
                        [step]="(sectionSteps$ | async)?.[i]"
                        [mapFile]="groupSelectedMapFile$ | async"></rwidget-stops-zones-selector>

                    <!-- product categories -->
                    <rwidget-product-category-selector
                        *ngSwitchCase="'TRAVELLER_CATEGORY'"
                        [step]="(sectionSteps$ | async)?.[i]"
                        [isEmpty]="i + 1 > pageProgress"
                        [locale]="locale"
                        type="traveller"></rwidget-product-category-selector>

                    <rwidget-product-category-selector
                        *ngSwitchCase="'PRODUCT_CATEGORY'"
                        [step]="(sectionSteps$ | async)?.[i]"
                        [isEmpty]="i + 1 > pageProgress"
                        [locale]="locale"
                        type="product"></rwidget-product-category-selector>

                    <rwidget-product-category-selector
                        *ngSwitchCase="'AREA_CATEGORY'"
                        [step]="(sectionSteps$ | async)?.[i]"
                        [isEmpty]="i + 1 > pageProgress"
                        [locale]="locale"
                        type="area"></rwidget-product-category-selector>

                    <!-- products -->
                    <rwidget-product-selector
                        *ngSwitchCase="'PRODUCT'"
                        [step]="(sectionSteps$ | async)?.[i]"
                        [isProductLoginRequired]="isProductLoginRequired"
                        [isEmpty]="i + 1 > pageProgress"
                        [isProductNotAllowed]="isProductNotAllowed"
                        [isPersonalizationRequired]="isPersonalizationRequired"
                        [locale]="locale"></rwidget-product-selector>

                    <!-- groups -->
                    <rwidget-group-selector
                        *ngSwitchCase="'GROUP'"
                        [groups]="groups$ | async"
                        [groupSelected]="groupSelected$ | async"
                        [step]="(sectionSteps$ | async)?.[i]"></rwidget-group-selector>

                    <ng-container *ngSwitchCase="'PRODUCT_QUANTITY'">
                        <rwidget-product-quantity-selector
                            *ngIf="showSelectedProductQuantity$ | async"
                            [step]="(sectionSteps$ | async)?.[i]"
                            (amountChanged)="changeSelectedProductQuantity($event)"></rwidget-product-quantity-selector>
                    </ng-container>

                    <!-- validity -->
                    <rwidget-validity
                        *ngSwitchCase="'VALIDITY'"
                        [step]="(sectionSteps$ | async)?.[i]"
                        [isEmpty]="i + 1 > pageProgress"></rwidget-validity>

                    <!-- medium -->
                    <rwidget-purchase-medium
                        *ngSwitchCase="'MEDIUM'"
                        [locale]="locale"
                        [step]="(sectionSteps$ | async)?.[i]"
                        [isEmpty]="i + 1 > pageProgress"></rwidget-purchase-medium>
                </ng-container>
            </ng-container>
            <rwidget-notifications
                *ngIf="
                    (selectedProduct$ | async)?.notification_mask &&
                    (selectedMediumGroup$ | async) &&
                    (selectedMediumGroup$ | async).type !== 'Email'
                "
                [step]="notificationsStep$ | async"
                [productMask]="(selectedProduct$ | async)?.notification_mask"></rwidget-notifications>
        </ridango-page-content-wrapper>

        <!-- summary -->
        <div
            class="block--bg-wrapper ticket-summary"
            *ngIf="!env.IS_CORPORATE || corporateTravelCardsSelected"
            [ngClass]="{ 'mb-extra-space-for-mobile': env.IS_MOBILE_APP }">
            <h2 class="title-bg-wrapper">
                {{ 'PAGE_TITLE_YOUR_TICKET' | translate }}
            </h2>

            <ridango-page-content-wrapper>
                <rwidget-purchase-summary
                    [flowCompleted]="isFlowCompleted$ | async"
                    [locale]="locale"
                    [tickets]="tickets$ | async"
                    [hasZoneModal]="hasZoneModal"
                    (postPayloads)="postToCart()"
                    (requestRemoveCard)="removeCardFromTicket($event)"></rwidget-purchase-summary>
            </ridango-page-content-wrapper>
        </div>
    </div>
</div>
